import React, { useState } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ParentList from "./ParentList";
import PaperPurchases from "./PaperPurchases";
import MobileUsers from "./MobileUsers";

const TAB_COURSE = 0;
const TAB_MOCK = 1;
const TAB_PAPER = 2;
const TAB_MOBILE = 3;

const AdminBillingTransactions = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ mb: 3 }}>
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1.5,
            mb: 1,
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            borderRadius: 2,
            px: 2.5,
            py: 1,
            boxShadow: "0 4px 15px rgba(102, 126, 234, 0.25)",
          }}
        >
          <ReceiptLongIcon sx={{ color: "white", fontSize: 28 }} />
          <Typography variant="h6" sx={{ fontWeight: 700, color: "white" }}>
            Billing &amp; Transactions
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ ml: 0.5 }}>
          Manage course, mock exam, and paper billing in one place.
        </Typography>
      </Box>

      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        sx={{
          mb: 2,
          "& .MuiTab-root": { fontWeight: 600, textTransform: "none" },
          "& .Mui-selected": { color: "primary.main" },
        }}
      >
        <Tab label="Course" id="billing-tab-0" aria-controls="billing-panel-0" />
        <Tab label="Mock Exam" id="billing-tab-1" aria-controls="billing-panel-1" />
        <Tab label="Paper" id="billing-tab-2" aria-controls="billing-panel-2" />
        <Tab label="Mobile App" id="billing-tab-3" aria-controls="billing-panel-3" />
      </Tabs>

      <Box role="tabpanel" hidden={tabValue !== TAB_COURSE} id="billing-panel-0" aria-labelledby="billing-tab-0">
        {tabValue === TAB_COURSE && (
          <Box sx={{ pt: 0 }}>
            <ParentList forceBillingView billingType="course" />
          </Box>
        )}
      </Box>
      <Box role="tabpanel" hidden={tabValue !== TAB_MOCK} id="billing-panel-1" aria-labelledby="billing-tab-1">
        {tabValue === TAB_MOCK && (
          <Box sx={{ pt: 0 }}>
            <ParentList forceBillingView billingType="mock" />
          </Box>
        )}
      </Box>
      <Box role="tabpanel" hidden={tabValue !== TAB_PAPER} id="billing-panel-2" aria-labelledby="billing-tab-2">
        {tabValue === TAB_PAPER && (
          <Box sx={{ pt: 0 }}>
            <PaperPurchases />
          </Box>
        )}
      </Box>
      <Box role="tabpanel" hidden={tabValue !== TAB_MOBILE} id="billing-panel-3" aria-labelledby="billing-tab-3">
        {tabValue === TAB_MOBILE && (
          <Box sx={{ pt: 0 }}>
            <MobileUsers />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AdminBillingTransactions;
